"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _StringHelper = require("../Utilities/StringHelper");

var _classnames = _interopRequireDefault(require("classnames"));

var _green = _interopRequireDefault(require("@material-ui/core/colors/green"));

var _red = _interopRequireDefault(require("@material-ui/core/colors/red"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var _DateHelper = require("../Utilities/DateHelper");

var _ArrowRight = _interopRequireDefault(require("@material-ui/icons/ArrowRight"));

var _deprecated = _interopRequireDefault(require("prop-types-extra/lib/deprecated"));

var validShapes = {
  circle: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    "data-testid": "circle",
    fontSize: "inherit"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12"
  })),
  triangle: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    "data-testid": "triangle",
    fontSize: "inherit"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "12 1.6, 0 22.4, 24 22.4"
  })),
  square: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    "data-testid": "square",
    fontSize: "inherit"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "0 0, 0 24, 24 24, 24 0"
  })),
  pentagon: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    "data-testid": "pentagon",
    fontSize: "inherit"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "12,0 24,9 20,24 4,24 0,9.2"
  })),
  hexagon: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    "data-testid": "hexagon",
    fontSize: "inherit"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "24,12 18,22 6,22 0,12 6,2 18,2 24,12"
  })),
  octagon: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    "data-testid": "octagon",
    fontSize: "inherit"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "0,8 0,16 8,24 16,24 24,16 24,8 16,0 8,0"
  })),
  clock: /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    id: "mdi-progress-clock",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z"
  }))
};
var defaultStatuses = {
  DELETED: {
    shape: "octagon",
    color: _red.default[500]
  },
  DRAFT: {
    shape: "pentagon",
    color: "#7a5d83"
  },
  SUBMITTED: {
    shape: "triangle",
    color: "#375d77"
  },
  DECLINED: {
    shape: "square",
    color: "#e8b10e"
  },
  ARCHIVED: {
    shape: "hexagon",
    color: "#ec884f"
  },
  PUBLISHED: {
    shape: "circle",
    color: _green.default[500]
  },
  CUSTOM: {
    shape: "triangle",
    color: "#ec884f"
  }
};

var StatusIndicator = function StatusIndicator(props) {
  StatusIndicator.propTypes = {
    /**
     * The html id
     */
    id: _propTypes.default.string,

    /**
     * @ignore
     *
     * Utilizing this to style up the page don't want to expose this in the style guide.
     * Auto-populated by material-ui withStyles()
     */
    classes: _propTypes.default.object.isRequired,

    /**
     * @ignore
     *
     * Utilized By:
     * CivicEngage, CP Platform
     */
    className: _propTypes.default.string,

    /**
     * The status to show, for a custom status use CUSTOM
     */
    status: _propTypes.default.oneOf(Object.keys(defaultStatuses)).isRequired,

    /**
     * The string to show for a custom status
     */
    customText: _propTypes.default.string,

    /**
     * Whether to show the text representation of the status
     */
    showText: _propTypes.default.bool,

    /**
     * A manual color to override
     */
    color: _propTypes.default.string,

    /**
     * A manual shape to override
     */
    shape: _propTypes.default.oneOf(Object.keys(validShapes)),

    /**
     * @deprecated
     * A scheduled status that will take effect on the `scheduledDate` date. Use the pending status props instead
     */
    scheduledStatus: (0, _deprecated.default)(_propTypes.default.oneOf(Object.keys(defaultStatuses)), "Use the pending status instead."),

    /**
     * The date that the pending (or deprecated scheduled) status will take effect
     */
    scheduledDate: _propTypes.default.instanceOf(Date),

    /**
     * @deprecated
     * The string to show for a custom scheduled status. Use the pending status props instead
     */
    scheduledCustomText: (0, _deprecated.default)(_propTypes.default.string, "Use the pending status instead."),

    /**
     * Props for the pending status
     */
    pending: _propTypes.default.shape({
      /**
       * The pending status to show, for a custom status use CUSTOM
       */
      status: _propTypes.default.oneOf(Object.keys(defaultStatuses)),

      /**
       * The string to show for a custom pending status
       */
      customText: _propTypes.default.string,

      /**
       * A manual color to override for the pending status
       */
      color: _propTypes.default.string,

      /**
       * A manual shape to override for the pending status
       */
      shape: _propTypes.default.oneOf(Object.keys(validShapes))
    })
  };
  var className = props.className,
      status = props.status,
      classes = props.classes,
      showText = props.showText,
      shape = props.shape,
      color = props.color,
      customText = props.customText,
      scheduledStatus = props.scheduledStatus,
      scheduledDate = props.scheduledDate,
      scheduledCustomText = props.scheduledCustomText,
      pending = props.pending,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "status", "classes", "showText", "shape", "color", "customText", "scheduledStatus", "scheduledDate", "scheduledCustomText", "pending"]);
  var currentUppercaseStatus = status.toUpperCase();
  var renderedCurrentStatus = currentUppercaseStatus === "CUSTOM" && customText ? customText : (0, _StringHelper.capitalizeFirstLetter)(status.toLowerCase());
  var renderedPendingStatus = undefined;
  var renderedPendingShape = undefined;
  var shouldRenderPending = Boolean(pending && pending.status);

  if (shouldRenderPending) {
    var pendingUppercaseStatus = pending.status.toUpperCase();
    renderedPendingStatus = pendingUppercaseStatus === "CUSTOM" && pending.customText ? pending.customText : (0, _StringHelper.capitalizeFirstLetter)(pending.status.toLowerCase());
    renderedPendingShape = /*#__PURE__*/_react.default.createElement("span", {
      "data-testid": "shape-pending",
      style: {
        color: pending.color ? pending.color : defaultStatuses[pendingUppercaseStatus].color
      },
      className: (0, _classnames.default)(classes.icon, classes.noPadding)
    }, pending.shape ? validShapes[pending.shape] : validShapes[defaultStatuses[pendingUppercaseStatus].shape]);
  }

  var useDeprecatedScheduledProps = Boolean(scheduledStatus);

  if (useDeprecatedScheduledProps) {
    var scheduledUppercaseStatus = scheduledStatus.toUpperCase();
    renderedPendingStatus = scheduledUppercaseStatus === "CUSTOM" && scheduledCustomText ? scheduledCustomText : (0, _StringHelper.capitalizeFirstLetter)(scheduledStatus.toLowerCase());
    renderedPendingShape = /*#__PURE__*/_react.default.createElement("span", {
      "data-testid": "shape-pending",
      style: {
        color: defaultStatuses[scheduledUppercaseStatus].color
      },
      className: (0, _classnames.default)(classes.icon, classes.noPadding)
    }, validShapes[defaultStatuses[scheduledUppercaseStatus].shape]);
  }

  var renderedCurrentShape = /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "shape-current",
    style: {
      color: color ? color : defaultStatuses[currentUppercaseStatus].color
    },
    className: (0, _classnames.default)(classes.icon, (0, _defineProperty2.default)({}, classes.noPadding, shouldRenderPending || useDeprecatedScheduledProps))
  }, shape ? validShapes[shape] : validShapes[defaultStatuses[currentUppercaseStatus].shape]);

  var currentStatusSymbol = showText ? renderedCurrentShape : /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: shouldRenderPending || useDeprecatedScheduledProps ? "Current version is ".concat(renderedCurrentStatus) : renderedCurrentStatus
  }, renderedCurrentShape);
  var pendingStatusSymbol = renderedPendingShape && showText ? renderedPendingShape : renderedPendingShape ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: scheduledDate ? "New version is scheduled to be ".concat(renderedPendingStatus, " ").concat((0, _DateHelper.getFormattedDateStringRelative)(scheduledDate)) : "New version is ".concat(renderedPendingStatus)
  }, renderedPendingShape) : undefined;

  var renderedText = /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.description
  }, shouldRenderPending ? "Current version is ".concat(renderedCurrentStatus, ", new version is ").concat(renderedPendingStatus) : scheduledDate ? "Current version is ".concat(renderedCurrentStatus, ", new version is scheduled to be ").concat(renderedPendingStatus, " ").concat((0, _DateHelper.getFormattedDateStringRelative)(scheduledDate)) : renderedCurrentStatus);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    "data-status": currentUppercaseStatus,
    "data-pendingstatus": shouldRenderPending ? pending.status.toUpperCase() : undefined,
    "data-scheduledstatus": scheduledStatus ? scheduledStatus.toUpperCase() : undefined,
    "data-scheduleddate": scheduledDate,
    className: (0, _classnames.default)("prmbl-statusIndicator", className, classes.root)
  }, otherProps), currentStatusSymbol, (shouldRenderPending || scheduledDate) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ArrowRight.default, {
    className: classes.separator
  }), pendingStatusSymbol), showText && renderedText);
};

StatusIndicator.defaultProps = {
  showText: true
};

var _default = (0, _styles2.withStyles)(_styles.styles)(StatusIndicator);

exports.default = _default;